import { Directive, Input, ElementRef, AfterViewChecked, HostListener, ViewChild } from '@angular/core';
import { timeout } from 'q';

@Directive({
  selector: '[setHeight]'
})
export class SetHeightDirective implements AfterViewChecked {

  constructor(private element: ElementRef) { }

  private _elementTop: number;
  private _setHeight: string = 'default';

  @Input() set setHeight(value: string
    // = 'default'
    )
  {
    this._setHeight = value;
    this.setElementHeight(this.element.nativeElement);
  }

  //windowHeight: number;

  @HostListener('window:resize') OnResize(){
    //this.windowHeight = window.innerHeight;
    this.setElementHeight(this.element.nativeElement);
  }

  @ViewChild('footer', /* TODO: add static flag */ {static: true}) footer;

  ngOnChanges(){
    //this._elementTop = this.element.nativeElement.getBoundingClientRect().top > 0 ? this.element.nativeElement.getBoundingClientRect().top : this._elementTop;
    //this.setElementHeight(this.element.nativeElement);
  }

  ngAfterViewInit(){
    setTimeout(() => {
      if(this._setHeight.endsWith('w')){
        this._elementTop = this.element.nativeElement.getBoundingClientRect().top > 0 ? this.element.nativeElement.getBoundingClientRect().top : this._elementTop;
        //this._elementTop = 170;
        this.setElementHeight(this.element.nativeElement);
      }
    }, 1000);
  }

  ngAfterViewChecked(){
    //if(this._setHeight.endsWith('w')){
      //this._elementTop = this.element.nativeElement.getBoundingClientRect().top > 0 ? this.element.nativeElement.getBoundingClientRect().top : this._elementTop;
      //this.setElementHeight(this.element.nativeElement);
    //}
    
    //console.log('ngAfterViewChecked');
  }

  setElementHeight(element: HTMLElement){
    //let directive = this;
    //setTimeout(function(){
      //element.style.height = (window.innerHeight - element.getBoundingClientRect().top - this.getFooterHeight()).toString() + 'px';
      let windowWidth = window.screen.availWidth * window.devicePixelRatio;
      let windowRatio = 1;
      if(windowWidth <= 1100){
        windowRatio = 2;
      }

      if(this._setHeight == '100w')
        element.style.height = parseInt(((window.innerHeight / windowRatio) - this._elementTop - this.getFooterHeight()).toString()) + 'px';
      else if(this._setHeight == '100c' && element.offsetParent)
        element.style.height = element.offsetParent.clientHeight - element.offsetTop + 'px';
      else if(this._setHeight.indexOf('px') > -1)
        element.style.height = this._setHeight;
      //console.log('setElementHeight');
    //}, 500);
  }

  private getFooterHeight(): number{
    let footer: Element = document.getElementsByClassName('default-footer')[0];
    return footer ? footer.clientHeight : 0;
  }

}
